import React from 'react'
import HeaderIconsGroup from '../shared/HeaderIconsGroup'
import { useTranslation } from 'react-i18next';

const PendingSignatureCard = ({ isLoan, isIgr, IconSatis, IconExcl, IconMult, mp }) => {
    const { t } = useTranslation();

    return (
        <div className="card-early">
            <p className='title-cards-early'><b>{t('extended_report.projects_pending_signature')}</b></p>
            <HeaderIconsGroup
                showValues={Boolean(isLoan | isIgr)}
                projectsLabel={t('one_pager_report.projects')}
                items={[
                    {
                        Icon: IconSatis,
                        text: t('extended_report.within_the_regulatory_time'),
                        value: mp.ProjectPendingSignedAlertTypes.satisfactoryType,
                    },
                    {
                        Icon: IconExcl,
                        text: t('extended_report.up_to_one_year_extension'),
                        value: mp.ProjectPendingSignedAlertTypes.warningType,
                    },
                    {
                        Icon: IconMult,
                        text: t('extended_report.more_than_a_year_of_extension'),
                        value: mp.ProjectPendingSignedAlertTypes.alertType,
                    },
                ]}
            />
        </div>
    )
}

export default PendingSignatureCard